"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slatePlugins = require("@udecode/slate-plugins");
var _element = _interopRequireDefault(require("./element"));
var deserializeDiv = function deserializeDiv(options) {
  var _setDefaults = (0, _slatePlugins.setDefaults)(options, _element["default"]),
    div = _setDefaults.div;
  return {
    element: (0, _slatePlugins.getElementDeserializer)({
      type: div.type,
      rules: [{
        nodeNames: 'DIV'
      }]
    })
  };
};
var _default = exports["default"] = deserializeDiv;